import React, { useState, useEffect } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import swal from "sweetalert";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Grid, Box, Typography, IconButton, Button, TextField, Dialog, DialogTitle, DialogContent, Slider, InputAdornment, DialogActions, Select, MenuItem, CircularProgress, Card, CardContent } from "@mui/material";
import { FormatAlignLeft, FormatAlignCenter, FormatAlignRight } from '@mui/icons-material';
import Freez from '../../../Components/Loader/Loader'
import DefaultLayout from '../../../Components/DefaultLayout';
import Backdrop from '@mui/material/Backdrop';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ImageIcon from "@mui/icons-material/Image";
import Visibility from "@mui/icons-material/Visibility";
import "./emailEditor.css";
import PreheaderImg from '../../../assets/images/EmailEditor_Images/Preheader.png';
import HeaderImg from '../../../assets/images/EmailEditor_Images/Header.png';
import ParagraphImg from '../../../assets/images/EmailEditor_Images/Paragraph.png'
import ButtonImg from '../../../assets/images/EmailEditor_Images/Button.png';
import ImageImg from '../../../assets/images/EmailEditor_Images/Image.png';
import FooterImg from '../../../assets/images/EmailEditor_Images/Footer.png';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { fetchData, postFormData } from "../../../redux/apiSlice";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import * as Yup from 'yup';
import moment from 'moment-timezone';
import { Formik, Form } from 'formik';
import { ChromePicker } from "react-color";
const isAuthenticated = localStorage.getItem('isAuthenticated')
console.log(isAuthenticated, 'isAuthenticated')

const ItemType = "email-section";
const itemImages = {
    Preheader: PreheaderImg,
    Header: HeaderImg,
    Paragraph: ParagraphImg,
    Button: ButtonImg,
    Image: ImageImg,
    Footer: FooterImg
};
const DraggableItem = ({ type }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: ItemType,
        item: { type },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }));
    return (
        <Box
            ref={drag}
            className="editorItem"
            sx={{ opacity: isDragging ? 0.5 : 1, cursor: "grab", padding: "8px", border: "1px solid gray", textAlign: "center" }}
        >
            <img src={itemImages[type]} alt={type} style={{ width: "40px", height: "40px", marginBottom: "8px" }} />
            <Typography>{type}</Typography>
        </Box>
    );
};
const DraggableRow = ({ children, type, rowKey }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: ItemType,
        item: { type, rowKey },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }));
    return (
        <Box ref={drag} className="dragablerow" sx={{ opacity: isDragging ? 0.5 : 1 }}>
            {children}
        </Box>
    );
}
const EmailSection = ({ section, className, onDrop, onDelete, onClick, selectedSectionKey, handleReplaceImage, editorData, setEditorData, updateSectionContent }) => {
    const isEditing = section.key === selectedSectionKey;
    const [{ isOver }, drop] = useDrop(() => ({
        accept: "email-section",
        drop: (item) => onDrop(section.key, item.type),
        collect: (monitor) => ({ isOver: monitor.isOver() }),
    }));
    const hasContent = section.content && section.content.replace(/<[^>]*>/g, "").trim() !== "";
    const hasImage = Boolean(section.imageSrc);
    const isImageSection = section.key.startsWith("image");
    const isButtonSection = section.key.startsWith("button");
    const handleEditorChange = (value) => {
        setEditorData(value);
        updateSectionContent(section.key, value);
    };
    const renderButton = () => (
        <Button
            variant="contained"
            sx={{
                backgroundColor: section?.styles?.bgColor || "#9225FF",
                color: section?.styles?.textColor || "#FFFFFF",
                border: section?.styles?.borderColor ? `2px solid ${section.styles.borderColor}` : "none",
                padding: section?.styles?.padding || "4px 12px",
                fontSize: section?.styles?.fontSize || "0.8rem",
                borderRadius: section?.styles?.borderRadius || "4px",
                minWidth: "100px",
            }}
        >
            {section.content?.replace(/<[^>]*>/g, "") || "Button Text"}
        </Button>
    );
    const renderDeleteButton = () => (
        <Box className="iconContainer">
            <IconButton size="small" onClick={() => onDelete(section.key)}>
                <DeleteIcon fontSize="small" />
            </IconButton>
        </Box>
    );
    const renderTextContent = () => (
        section?.isRichText ? (
            <Typography
                variant="body2"
                sx={{ marginTop: "8px" }}
                dangerouslySetInnerHTML={{ __html: section.content || "" }}
            />
        ) : (
            <Typography variant="body2" sx={{ marginTop: "8px" }}>
                {section.content?.replace(/<[^>]*>/g, "") || ""}
            </Typography>
        )
    );
    return (
        <Box
            ref={drop}
            className={className}
            onClick={onClick}
            sx={{
                backgroundColor: section.bgColor || "#F3F9FF",
                border: isEditing ? `1px solid #2E67BC` : section.borderColor ? `2px solid ${section.borderColor}` : "none",
                color: section.textColor || "black",
                position: "relative",
                boxShadow: isEditing ? "0px 0px 12px rgba(180, 200, 230, 0.5)" : "none",
            }}
        >
            {isImageSection && (
                <Box sx={{ width: "100%", display: "flex", justifyContent: section.alignment === "center" ? "center" : section.alignment === "left" ? "flex-start" : "flex-end" }}>
                    {section.imageSrc ? (
                        <img
                            src={section.imageSrc}
                            alt="Uploaded"
                            style={{
                                width: section.imageWidth ? `${section.imageWidth}%` : "100%",
                                maxWidth: "100%",
                                height: "auto",
                                display: "block",
                                objectFit: "cover",
                                margin: section.alignment === "center" ? "0 auto" : section.alignment === "left" ? "0" : "0 0 0 auto",
                            }}
                        />
                    ) : (
                        <Box sx={{ textAlign: "center" }}>
                            <Button
                                variant="outlined"
                                component="label"
                                sx={{
                                    border: "2px dashed #ccc",
                                    padding: "10px",
                                    cursor: "pointer",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <img src={require("../../../assets/icons/galleryImg.png")} alt="Gallery Icon" width={50} />
                                <Typography>Browse Image</Typography>
                                <input type="file" accept="image/*" hidden onChange={handleReplaceImage} />
                            </Button>
                        </Box>
                    )}
                </Box>
            )}
            {!isEditing && (
                <>
                    {!hasContent && !hasImage && !isImageSection && !isButtonSection && (
                        <Typography variant="body2" sx={{ padding: "8px", fontStyle: "italic" }}>{section.title}</Typography>
                    )}
                    {isButtonSection && (
                        <Box sx={{ position: "relative", width: "100%", zIndex: 1, display: "flex", justifyContent: section?.styles?.alignment === "left" ? "flex-start" : section?.styles?.alignment === "right" ? "flex-end" : "center" }}>
                            {renderButton()}
                        </Box>
                    )}
                    {!isImageSection && !isButtonSection && renderTextContent()}
                </>
            )}
            {isEditing && !isImageSection && !isButtonSection && (
                <>
                    {renderDeleteButton()}
                    <Box
                        sx={{
                            position: "relative", width: "100%",
                            "& .ql-container": { overflowX: "hidden" },
                            "& .ql-editor": { padding: "6px", fontSize: "0.85rem", wordBreak: "break-word", whiteSpace: "pre-wrap", zIndex: 2 },
                            "& .ql-toolbar": {
                                display: "flex", flexWrap: "nowrap", whiteSpace: "nowrap", scrollbarWidth: "none", msOverflowStyle: "none",
                                "&::-webkit-scrollbar": { display: "none" },
                                "& .ql-formats": { display: "flex", flexShrink: 0 },
                            },
                        }}
                    >
                        <ReactQuill
                            value={editorData}
                            onChange={handleEditorChange}
                            modules={{
                                toolbar: [[{ size: ["small", false, "large", "huge"] }], ["bold", "italic", "underline"], ["link"], [{ list: "ordered" }, { list: "bullet" }]],
                            }}
                            formats={["bold", "italic", "underline", "link", "list", "bullet", "size"]}
                            placeholder={`Edit ${section.title}`}
                        />
                    </Box>
                </>
            )}
            {isEditing && isButtonSection && (
                <Box sx={{ position: "relative", width: "100%", display: "flex", alignItems: "center", padding: "10px" }}>
                    <Box sx={{ flexGrow: 1, display: "flex", justifyContent: section?.styles?.alignment === "left" ? "flex-start" : section?.styles?.alignment === "right" ? "flex-end" : "center" }}>
                        {renderButton()}
                    </Box>
                    <IconButton size="small" onClick={() => onDelete(section.key)} sx={{ marginLeft: "auto", color: "#2E67BC" }}>
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                </Box>
            )}
            {isEditing && isImageSection && renderDeleteButton()}
        </Box>
    );
};
const EmailEditor = () => {
    const [freez, setFreez] = React.useState(false);
    const [emailSections, setEmailSections] = useState([]);
    const [editorData, setEditorData] = useState("");
    const [bgColor, setBgColor] = useState("#F3F9FF");
    const [borderColor, setBorderColor] = useState("#8E63D3");
    const [textColor, setTextColor] = useState("#2E67BC");
    const [openPicker, setOpenPicker] = useState(null);
    const [selectedSectionKey, setSelectedSectionKey] = useState(null);
    const [selectedSection, setSelectedSection] = useState(null);
    const [htmlContent, setHtmlContent] = useState("");
    const [openPreview, setOpenPreview] = useState(false);
    const [activeTab, setActiveTab] = useState("section");
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    const togglePicker = (type) => {
        setOpenPicker((prev) => (prev === type ? null : type));
    }; //TO CLOSE THE THE COLOR PICKER AFTER CLICKING
    useEffect(() => {
        if (!openPicker) return;
        const handleClickOutside = (e) => {
            if (!e.target.closest(".chrome-picker") && !e.target.classList.contains("color-box")) {
                setOpenPicker(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [openPicker]);
    const navigate = useNavigate();
    const location = useLocation() // State to store the previously selected section key
    const [prevSelectedKey, setPrevSelectedKey] = useState(null);
    const handleReset = () => {
        setEmailSections([]); // Reset drop section
        setSelectedSectionKey(null);
        setSelectedSection(null);
        setActiveTab("section");
        navigate(location.pathname, { replace: true, state: {} });    //  Clear location state
    };
    // TO SHOW THE TAB BASED ON THE PARTICULAR EDIT SECTION CLICK
    useEffect(() => {
        if (selectedSectionKey !== null) {
            const selectedItem = emailSections
                .flatMap((section) => section.children.flatMap((column) => column.content))
                .find((item) => item.key === selectedSectionKey);
            if (prevSelectedKey !== selectedSectionKey) {
                setActiveTab(["image", "button"].includes(selectedItem?.type) ? "style" : "content");  //  auto-switch  tab if it Is not manually selected
            }
            setPrevSelectedKey(selectedSectionKey);   //last edited section key
        }
    }, [selectedSectionKey, emailSections]);
    const selectedRows = location.state?.selectedRows || [];
    // console.log(selectedRows)
    const uploadedFile = location.state?.uploadedFile || null;
    // console.log("Uploaded File:", uploadedFile);
    const emailContent = location.state?.content || "";
    console.log('emailContent', emailContent)
    const selectedReport = location.state?.selectedReport || null;
    // console.log("Selected Report:", selectedReport);
    const selectedDefaultTemplate = location.state?.template || null;
    // TO CREATE A TEMPLATE FROM SAVED EMAILS
    useEffect(() => {
        if (!emailContent) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(emailContent, "text/html");
        let extractedRows = [];
        let seenRowIds = new Set();
        const allRows = Array.from(doc.querySelectorAll("table > tbody > tr"));
        allRows.forEach((row, rowIndex) => {
            let extractedColumns = [];
            let rowId = `row-${rowIndex}`;
            if (seenRowIds.has(rowId)) return;
            seenRowIds.add(rowId);
            const allColumns = Array.from(row.children).filter(
                (td) => td.tagName.toLowerCase() === "td" && td.hasAttribute("width")
            );
            allColumns.forEach((column, colIndex) => {
                let textContent = column.innerText.trim();
                const styledElements = column.querySelectorAll("div");
                const buttonElement = column.querySelector("a, button");
                const imageElement = column.querySelector("img");
                let columnData = {
                    key: `column-${rowIndex}-${colIndex}`,
                    id: `column-${rowIndex}-${colIndex}`,
                    className: "column",
                    width: column.getAttribute("width"),
                    content: [],
                };
                if (styledElements.length > 0) {
                    styledElements.forEach((styledElement, divIndex) => {
                        const innerText = styledElement.innerText.trim();
                        const buttonInside = styledElement.querySelector("a, button");
                        if (buttonInside) {
                            columnData.content.push({
                                key: `button-${rowIndex}-${colIndex}-${divIndex}`,
                                id: `button-${rowIndex}-${colIndex}-${divIndex}`,
                                type: "button",
                                content: buttonInside.innerText.trim(),
                                styles: {
                                    bgColor: buttonInside.style.backgroundColor || styledElement.style.backgroundColor || column.style.backgroundColor || "#9225FF",
                                    textColor: buttonInside.style.color || styledElement.style.color || column.style.color || "#FFFFFF",
                                    borderColor: buttonInside.style.borderColor || styledElement.style.borderColor || "transparent",
                                    fontSize: buttonInside.style.fontSize || "14px",
                                    padding: buttonInside.style.padding || "5px 10px",
                                    borderRadius: buttonInside.style.borderRadius || "4px",
                                    alignment: buttonInside.style.margin === "0 auto" ? "center" : buttonInside.style.margin?.includes("0 0 0 auto") ? "right" : "left",
                                },
                            });
                        } else if (innerText) {
                            columnData.content.push({
                                key: `styled-${rowIndex}-${colIndex}-${divIndex}`,
                                id: `styled-${rowIndex}-${colIndex}-${divIndex}`,
                                type: "text", content: innerText,
                                bgColor: styledElement.style.backgroundColor?.trim() && styledElement.style.backgroundColor !== "transparent"
                                    ? styledElement.style.backgroundColor
                                    : column.style.backgroundColor?.trim() && column.style.backgroundColor !== "transparent"
                                        ? column.style.backgroundColor : "#F3F9FF", // default color 
                                textColor: styledElement.style.color || column.style.color || "#000",
                                borderColor: styledElement.style.borderColor || "transparent",
                            });
                        }
                    });
                }
                if (imageElement) {           // Handle image 
                    columnData.content.push({
                        key: `image-${rowIndex}-${colIndex}`,
                        id: `image-${rowIndex}-${colIndex}`,
                        type: "image",
                        imageSrc: imageElement.getAttribute("src"),
                        imageWidth: imageElement.style.width?.replace('%', '') || "100",
                        alignment: imageElement.style.margin === "0 auto" ? "center" : imageElement.style.margin?.includes("0 0 0 auto") ? "right" : "left",
                    });
                }
                if (columnData.content.length > 0) {
                    extractedColumns.push(columnData);
                }
            });
            if (extractedColumns.length > 0) {
                extractedRows.push({
                    key: rowId,
                    id: rowId,
                    type: "row",
                    className: "row",
                    children: extractedColumns,
                    isSavedTemplate: true,
                });
            }
        });
        console.log("Extracted Rows:", extractedRows);
        setEmailSections(extractedRows);
    }, [emailContent]);
    // TO CREATE A TEMPLATE FROM DEFAULT EMAILS
    useEffect(() => {
        if (!selectedDefaultTemplate?.layout) return;
        console.log("Selected Template:", selectedDefaultTemplate);
        const sectionTypes = {                  // section types
            "header": { key: "header", title: "Header", className: "header", type: "text" },
            "paragraph": { key: "paragraph", title: "Paragraph", className: "paragraph", type: "text" },
            "footer": { key: "footer", title: "Footer", className: "footer", type: "text" },
            "image": { key: "image", title: "Image", className: "image", type: "image", content: "" },
            "content-left": { key: "content-left", title: "Left Content", className: "content-left", type: "text" },
            "content-right": { key: "content-right", title: "Right Content", className: "content-right", type: "text" }
        };
        //TO Convert template layout into email sections structure
        const extractedSections = selectedDefaultTemplate.layout.map((row, rowIndex) => {
            const isMultiColumn = Array.isArray(row);  // Check if row has multiple columns
            return {
                key: `row-${rowIndex}`, // Unique row key
                type: "row",
                className: isMultiColumn ? "multi-column-row" : "full-width-row",
                children: (isMultiColumn ? row : [row]).map((col, colIndex) => {
                    const contentKey = `${col}-${rowIndex}-${colIndex}-${Date.now()}`; // Unique key
                    const content = [{ ...(sectionTypes[col] || sectionTypes["paragraph"]), key: contentKey }];
                    return {
                        key: `column-${rowIndex}-${colIndex}`, // Unique column key
                        className: isMultiColumn ? `grid-box column-${colIndex}` : "full-width",
                        content
                    };
                }),
            };
        });
        setEmailSections((prev) =>
            JSON.stringify(prev) === JSON.stringify(extractedSections) ? prev : extractedSections
        );
    }, [selectedDefaultTemplate]);
    // TO SHOW THE DEFAULT LAYOUT SELECTED
    useEffect(() => {
        if (emailSections.length === 0 && !selectedDefaultTemplate && !emailContent) {
            const defaultRow = {
                key: `default-row-${Date.now()}`,
                type: "row",
                className: "full-width-row",
                children: [
                    {
                        key: `column-0-${Date.now()}`,
                        className: "grid-box full-width",
                        content: []
                    }
                ]
            };
            setEmailSections([defaultRow]);
        }
    }, []);
    const handleDrop = (targetKey, droppedType, imageSrc = "", insertBeforeKey = null) => {
        console.log("Handling drop for targetKey:", targetKey, "Type:", droppedType);
        setEmailSections((prevSections) => {
            const rowTypes = {
                "full-width": { key: "full-width", title: "Full Width Row", className: "full-width-row", type: "row", columns: 1 },
                "half-width": { key: "half-width", title: "Two Equal Columns", className: "half-width-row", type: "row", columns: 2, columnWidths: ["half-width", "half-width"] },
                "large-small": { key: "large-small", title: "Large & Small Columns", className: "large-small-row", type: "row", columns: 2, columnWidths: ["large-10", "small-2"] },
                "small-large": { key: "small-large", title: "Small & Large Columns", className: "small-large-row", type: "row", columns: 2, columnWidths: ["small-2", "large-10"] }
            };
            const sectionTypes = {
                "Preheader": { key: "preheader", title: "Preheader", className: "preheader", type: "text" },
                "Header": { key: "header", title: "Header", className: "header", type: "text" },
                "Paragraph": { key: "paragraph", title: "Paragraph", className: "paragraph", type: "text" },
                "Footer": { key: "footer", title: "Footer", className: "footer", type: "text" },
                "Button": { key: "button", title: "Button", className: "button", type: "button", content: "Click Me" },
                "Image": { key: "image", title: "Image", className: "image", type: "image", imageSrc: imageSrc }
            }; //  If the dropped item is a ROW, add it with columns
            if (rowTypes[droppedType]) {
                const newRowConfig = rowTypes[droppedType];
                const newRow = {
                    ...newRowConfig,
                    key: `${newRowConfig.key}-${Date.now()}`,
                    children: newRowConfig.columnWidths
                        ? newRowConfig.columnWidths.map((className, index) => ({
                            key: `column-${index}-${Date.now()}`,
                            className: `grid-box ${className}`,
                            content: []
                        }))
                        : [{
                            key: `column-0-${Date.now()}`,
                            className: `grid-box full-width`,
                            content: []
                        }]
                };
                const indexToInsertAfter = prevSections.findIndex(section => section.key === targetKey);    // Find the index of the row where drop 
                if (indexToInsertAfter !== -1) {
                    const newSections = [...prevSections];        // Create  new array with  new row inserted after the targeted row
                    newSections.splice(indexToInsertAfter + 1, 0, newRow);    // Insert after the target row
                    return newSections;
                } else {
                    return [...prevSections, newRow];            // If no matching targetKey, append the row at the end (fallback)
                }
            } // If the dropped item is a SECTION
            if (sectionTypes[droppedType]) {
                const newSection = {
                    ...sectionTypes[droppedType],
                    key: `${sectionTypes[droppedType].key}-${Date.now()}`,
                };//  dropping inside an existing column
                if (targetKey) {
                    return prevSections.map((row) => ({
                        ...row,
                        children: row.children.map((column) => {
                            if (column.key === targetKey) {
                                const content = [...column.content];
                                console.log("Looking for insertBeforeKey:", insertBeforeKey);
                                const insertIndex = insertBeforeKey       // to Find the index where the new section should be inserted
                                    ? content.findIndex((item) => item.key === insertBeforeKey)
                                    : content.length; // If no insertBeforeKey append to the end.
                                if (insertIndex !== -1) {
                                    console.log(" Inserting BEFORE at index:", insertIndex);
                                    content.splice(insertIndex, 0, newSection); // Insert before
                                } else {
                                    content.push(newSection); // Append at the end
                                }
                                return {
                                    ...column,
                                    content
                                };
                            }
                            return column;
                        })
                    }));
                } else {
                    swal(" Action Required!", "Please select a layout before adding sections.", "warning");
                    return prevSections;
                }
            }
            return prevSections;
        });
    };
    const updateSectionContent = (sectionKey, newContent) => {  //TO UPDATE CONTENT OF THE EVERY SECTION
        setEmailSections(prev =>
            prev.map(row => ({
                ...row,
                children: row.children.map(col => ({
                    ...col,
                    content: col.content.map(section =>
                        section.key === sectionKey ? { ...section, content: newContent } : section
                    ),
                })),
            }))
        );
    };
    const handleEdit = (sectionKey, newContent) => {
        setEmailSections((prevSections) =>
            prevSections.map((section) => { // Iterate each section
                return {
                    ...section,
                    children: section.children.map((column) => {// Iterate each column
                        return {
                            ...column,
                            content: column.content.map((item) => { // Iterate each item 
                                if (item.key === sectionKey) { // Update the content of matching item
                                    return {
                                        ...item,
                                        content: newContent,
                                    };
                                }
                                return item;
                            }),
                        };
                    }),
                };
            })
        );
    };
    const handleDelete = (key) => {
        setEmailSections((prevSections) =>
            prevSections
                .map((section) => {
                    if (section.key === key) return null; // Remove the section
                    if (section.type === "row") {
                        const updatedChildren = section.children.map((column) => ({
                            ...column,
                            content: column.content.filter((item) => item.key !== key),
                        }));
                        return updatedChildren.every((col) => col.content.length === 0)
                            ? null  // Remove row if empty
                            : { ...section, children: updatedChildren };
                    }
                    return section;
                })
                .filter(Boolean) // TO Remove null values
        );
        if (selectedSectionKey === key) {
            setSelectedSectionKey(null);
            setEditorData("");
        }
    };
    const EmptyDropZone = ({ onDrop }) => {
        const [{ isOver }, drop] = useDrop(() => ({
            accept: "email-section",
            drop: (item) => onDrop(null, item.type),
            collect: (monitor) => ({ isOver: monitor.isOver() }),
        }));
        return (
            <Box ref={drop} sx={{ height: "250px", backgroundColor: isOver ? "#e0e0e0" : "transparent", display: "flex", alignItems: "center", justifyContent: "center", border: "1px dashed gray", margin: "16px" }}>
                <Typography variant="body2">Drop a layout here</Typography>
            </Box>
        );
    };
    const DropZone = ({ targetKey, onDrop, hideIfAboveRow, isEmpty, isRowDropZone = false, insertBeforeKey = null, isLastRow = false, }) => {
        const [{ isOver, draggedItem }, drop] = useDrop(() => ({
            accept: "email-section",
            drop: (item, monitor) => {
                if (!monitor.didDrop()) {// to prevent dropping section into a row drop zone
                    if (isRowDropZone && isSection(item.type)) {
                        return;
                    }
                    onDrop(targetKey, item.type, item.imageSrc || "", insertBeforeKey);
                }
            },
            collect: (monitor) => ({
                isOver: monitor.isOver(), draggedItem: monitor.getItem(),
            }),
        }));
        if (hideIfAboveRow) return null;// section type
        const isSection = (type) => {
            const validSections = ["Preheader", "Header", "Paragraph", "Footer", "Button", "Image"];
            return validSections.includes(type);
        };// Show error only if image is dropping over the row drop zone
        const showInvalidDropMessage =
            isRowDropZone && isOver && isSection(draggedItem?.type);
        return (
            <Box
                ref={drop}
                sx={{
                    width: "100%", height: isLastRow ? "180px" : isEmpty ? "100%" : "auto",
                    minHeight: "30px", backgroundColor: isOver ? "#f0f0f0" : "transparent",
                    border: showInvalidDropMessage ? "2px solid red" : "none",
                    display: "flex", alignItems: "center", justifyContent: "center", position: "relative", flexGrow: 1, pointerEvents: "auto",
                }}
            >
                {showInvalidDropMessage && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                        Sections can only be dropped inside a layout
                    </span>
                )}
                {isEmpty && !showInvalidDropMessage && "Drop sections Here"}
            </Box>
        );
    };
    useEffect(() => {
        if (selectedSectionKey) {
            const selectedSection = emailSections.find((s) => s.key === selectedSectionKey);
            if (selectedSection?.children) {
                const selectedItem = selectedSection.children
                    .flatMap((col) => col.content)
                    .find((item) => item.key === selectedSectionKey);

                if (!editorData) {
                    setEditorData(selectedItem?.content || "");
                }
            } else {
                if (!editorData) {
                    setEditorData(selectedSection?.content || "");
                }
            }
        }
    }, [selectedSectionKey]);
    const handleSectionClick = (key) => {
        const flatSections = emailSections.flatMap(section =>
            section.children ? section.children.flatMap(col => col.content) : [section]
        );
        const current = flatSections.find(item => item.key === selectedSectionKey);
        const next = flatSections.find(item => item.key === key);
        const isCurrentRichText = current?.type !== "button";
        const isNextRichText = next?.type !== "button";
        if (isCurrentRichText) {              // Save current content only if it's rich text
            setEmailSections(prev =>
                prev.map(section => {
                    if (section.key === selectedSectionKey) {
                        return { ...section, content: editorData, isRichText: true };
                    } else if (section.children) {
                        return {
                            ...section,
                            children: section.children.map(col => ({
                                ...col,
                                content: col.content.map(item =>
                                    item.key === selectedSectionKey
                                        ? { ...item, content: editorData, isRichText: true }
                                        : item
                                ),
                            })),
                        };
                    }
                    return section;
                })
            );
        }
        setSelectedSectionKey(key);         // Switch selection
        setTimeout(() => {                // Load new content (only for rich text)
            setEditorData(isNextRichText ? next?.content || "" : "");
        }, 0);
    };
    // Function to find a section's content based on key
    const handleColorChange = (property, value) => {
        setEmailSections((prevSections) =>
            prevSections.map((row) => ({
                ...row,
                children: row.children.map((column) => ({
                    ...column,
                    content: column.content.map((section) => {
                        if (section.key === selectedSectionKey) {
                            console.log("Updating Section Colors:", { property, value });
                            if (section.type === "button") {       // Handle button styles 
                                return {
                                    ...section,
                                    styles: {
                                        ...(section.styles || {}), // Preserve CURRENT styles
                                        [property]: value, // Update only the  style WHICH IS CHOOSEN
                                    },
                                };
                            }
                            return {
                                ...section,
                                [property]: value,
                            };
                        }
                        return section;
                    }),
                })),
            }))
        );
        if (property === "bgColor") {
            setBgColor(value);
        } else if (property === "borderColor") {
            setBorderColor(value);
        } else if (property === "textColor") {
            setTextColor(value);
        }
    };
    // Generate regex to match placeholders 
    const headers = [
        "Company Name", "First Name", "Last Name", "Email", "communication_email",
        "Phone no.", "address", "city", "state_code", "zip_code",
        "total_enrollements", "active_enrollements", "totalApprovedCommission", "paidAmount"
    ];
    const placeholderRegex = new RegExp(`\\*\\|(${headers.join('|')})\\|\\*`, 'g');
    const generateEmailTemplate = () => {
        let subjectplaceholders = new Set();
        let contentplaceholders = new Set();
        const extractPlaceholders = (text, placeholderSet) => {         // Function to extract placeholders
            if (!text) {
                console.log("Text is undefined or empty.");
                return;
            }
            console.log("Extracting from:", JSON.stringify(text));
            const matches = text.match(placeholderRegex);
            console.log("Match found:", matches);
            if (matches) {
                matches.forEach((match) => {
                    console.log("Adding placeholder:", match);
                    placeholderSet.add(match);
                });
            }
        };
        let content = `
        <!DOCTYPE html>
        <html lang="en-US">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Email Template</title>
            <style>
                .row { display: flex; width: 100%; justify-content: space-between; }
                .column { padding: 8px; min-height: 40px; box-sizing: border-box; }
                img { max-width: 100%; height: auto; display: block; }
            </style>
        </head>
        <body style="font-family: Arial, sans-serif; margin: 0; padding: 0; background-color: #f4f4f4;">
            <div style="width: 100%; background-color: #ffffff; padding: 10px;">
                  <!-- 
        <div style="font-size: 20px; font-weight: bold; color: #333333; text-align: center; margin-bottom: 10px;">
            ${subject || "Email Template"}
        </div> 
        -->
                <div style="width: 100%;">`;
        if (Array.isArray(emailSections) && emailSections.length > 0) {
            emailSections.forEach((row) => {
                if (!row || !row.children || !Array.isArray(row.children)) return;
                content += `
                <tr>
                    <td>
                        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="table-layout: fixed;">
                            <tr>
                `;
                let totalColumns = row.children.length;
                row.children.forEach((column, colIndex) => {
                    if (!column || !column.content || !Array.isArray(column.content)) return;
                    let widthPercentage = column.width ? `${(parseInt(column.width) / 12) * 100}%` : `${100 / totalColumns}%`;
                    if (row.columnWidths && row.columnWidths[colIndex]) {
                        const colSize = parseInt(row.columnWidths[colIndex].split('-')[1]);
                        if (!isNaN(colSize)) {
                            widthPercentage = `${(colSize / 12) * 100}%`;
                        }
                    }
                    content += `
                            <td width="${widthPercentage}" align="left" valign="top" style="padding: 10px;">
                                <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0">
                                    <tr>
                                        <td align="left" valign="top">
                    `;
                    column.content.forEach((section) => {
                        if (!section || !section.type) return;
                        const bgColor = (section.bgColor && section.bgColor !== "#F3F9FF") ? section.bgColor : "transparent";
                        const textColor = section.textColor || "#000";
                        const borderColor = section.borderColor || "transparent";
                        content += `<div id="${section.key}"  style="background-color: ${bgColor}; color: ${textColor}; border: 1px solid ${borderColor}; font-size: 12px;">`;
                        if (section.type === "text") {
                            content += `<p>${(section.content || "").replace(/class="ql-size-small"/g, 'style="font-size: 10px;"')
                                                                    .replace(/class="ql-size-large"/g, 'style="font-size: 18px;"')
                                                                    .replace(/class="ql-size-huge"/g, 'style="font-size: 30px;"')}</p>`;
                        }
                         else if (section.type === "button") {
                            const alignment = section.styles?.alignment || 'center';
                            let margin = "0";
                            if (alignment === "center") {
                                margin = "0 auto";
                            } else if (alignment === "right") {
                                margin = "0 0 0 auto";
                            }
                            content += `<a href="#" style="display: block; margin: ${margin};padding: ${section.styles?.padding || "5px 10px"}; font-size: ${section.styles?.fontSize || "14px"};
                                border-radius: ${section.styles?.borderRadius || "4px"}; background-color: ${section.styles?.bgColor || "#9225FF"};color: ${section.styles?.textColor || "#FFFFFF"};
                                border: 1px solid ${section.styles?.borderColor || "transparent"};text-decoration: none; width: fit-content; ">
                                ${(section.content || "").toUpperCase()}</a>`;
                        }
                        else if (section.type === "image" && section.imageSrc) {
                            const alignment = section.alignment || 'left';
                            const margin = alignment === 'center' ? '0 auto' : alignment === 'right' ? '0 0 0 auto' : '0';
                            const imageWidth = section.imageWidth ? section.imageWidth + '%' : '';
                            content += `<div style="text-align: ${alignment};">
                                            <img src="${section.imageSrc}" alt="Uploaded Image" 
                                                style="width: ${imageWidth};  
                                                        height: auto;
                                                        display: block;
                                                       margin: ${margin}">
                                        </div>`;
                        }
                        content += `</div>`;
                    });
                    content += `
                                        </td>
                                    </tr>
                                </table>
                            </td>
                    `;
                });
                content += `
                            </tr>
                        </table>
                    </td>
                </tr>
                `;
            });
        } else {
            content += `<p style="text-align: center; color: #888;">No content</p>`;
        }
        content += `
                </div>
                <div style="text-align: center; font-size: 14px; color: #888888; margin-top: 10px; padding-top: 10px;">
                    <p>Thank you for your time!</p>
                </div>
            </div>
        </body>
        </html>`;
        extractPlaceholders(content, contentplaceholders);
        setHtmlContent(content);
        return {
            subject, content, subjectPlaceholders: Array.from(subjectplaceholders),
            contentPlaceholders: Array.from(contentplaceholders)
        };
    };
    const dispatch = useDispatch();
    const [openEmailPopup, setOpenEmailPopup] = useState(false);
    const [subject, setSubject] = useState("")
    const [templateName, setTemplateName] = useState("");
    const [openCSVPopup, setOpenCSVPopup] = useState(false);  // State to OPEN CSV popup
    const handleSendEmailClick = () => {
        setOpenEmailPopup(true);
    };
    const [openScheduleSection, setOpenScheduleSection] = useState(false);
    const handleScheduleLaterClick = () => {
        setOpenScheduleSection(true); // Show the date/time 
    };
    const handleCancelClick = () => {
        setOpenScheduleSection(false); // Hide the date/time 
    };
    const [openSaveDraftPopup, setOpenSaveDraftPopup] = useState(false);
    const handleSaveDraftClick = () => {
        setOpenSaveDraftPopup(true);
    };
    const [openTestEmailPopup, setOpenTestEmailPopup] = useState(false);
    // Function to open the popup 
    const handleSendTestEmailClick = () => {
        setOpenTestEmailPopup(true);
    };
    const [emailAddresses, setEmailAddresses] = useState("");
    const handleEmailChange = (event) => {
        setEmailAddresses(event.target.value);
    }
    const [availableReports, setAvailableReports] = useState([]);
    const [chosenReport, setChosenReport] = useState("");
    const [loadingReports, setLoadingReports] = useState(false);
    const isUsingFetchedRecipients = uploadedFile || selectedReport || (selectedRows && selectedRows.length > 0);
    useEffect(() => {
        if (openEmailPopup && availableReports.length === 0) {
            fetchSavedReports();
        }
    }, [openEmailPopup]);
    const fetchSavedReports = async () => {
        try {
            setLoadingReports(true);
            const res = await dispatch(fetchData("/reports/all")).unwrap();
            if (res?.success) {
                setAvailableReports(res.data.map(item => ({ id: item.id, name: item.report_name, file: item.file })));
            } else {
                swal("Error!", "Something went wrong!", "error");
            }
        } catch (error) {
            swal("Error!", "Failed to fetch saved reports", "error");
        } finally {
            setLoadingReports(false);
        }
    };
    const handleSaveDraft = async () => {
        let token = localStorage.getItem("token");
        if (!token) {
            console.log("No token found");
            swal("Authentication Error", "No token found! Please log in again.", "error");
            return;
        }
        if (!emailSections || emailSections.length === 0) {
            swal("Empty Email", "Please add some content.", "warning");
            return;
        }
        if (!subject?.trim()) {
            swal("Missing Subject", "Enter a subject for the email.", "warning");
            return;
        }
        if (!templateName?.trim()) {
            swal("Missing Template Name", "Enter a template name.", "warning");
            return;
        }
        let { content } = generateEmailTemplate();
        const formData = new FormData();
        formData.append("subject", subject);
        formData.append("content", content);
        formData.append("template_name", templateName);
        if (uploadedFile) {
            console.log("CSV File Name:", uploadedFile.name);
            formData.append("file", uploadedFile);
        } else {
            console.log("No CSV file attached.");
        }
        const apiUrl = "/template/save";
        try {
            const res = await dispatch(postFormData({ apiUrl, formData })).unwrap();

            if (res && res.success === true) {
                swal("Success!", "Draft saved successfully!", "success").then(() => {
                    setOpenSaveDraftPopup(false);
                    setSubject("");
                    setTemplateName("");
                    setEmailSections([]);
                    setEditorData("");
                });
            } else {
                const errorMessage = res.message?.message || res.message?.messageAll?.[0] || res.message || res.error?.message || "Something went wrong!";
                swal("Error!", errorMessage, "error");
            }
        } catch (error) {
            console.log("Error saving draft:", error);
            const errorMessage = error?.error?.message || error?.message || "Failed to save draft";
            swal("Error!", errorMessage, "error");
        }
    };
    const handleSendTestEmail = async () => {
        const apiUrl = "/sentEmails/send";
        const token = localStorage.getItem("token");
        if (!token) {
            console.log("No token found");
            swal("Authentication Error", "No token found! Please log in again.", "error");
            return;
        }
        if (!emailSections || emailSections.length === 0) {
            swal("Missing Content", "Email content is empty.", "warning");
            return;
        }
        const { subject, content } = generateEmailTemplate();
        if (!subject?.trim()) {
            swal("Missing Subject", "Enter a subject.", "warning");
            return;
        }
        if (!emailAddresses?.trim()) {
            swal("Missing Email", "Enter at least one email.", "warning");
            return;
        }
        const recipients = emailAddresses
            .split(',')
            .map(email => email.trim())
            .filter(Boolean);
        const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        const invalidEmails = recipients.filter(email => !isValidEmail(email));
        if (invalidEmails.length > 0) {
            swal("Invalid Email", "Please check the email format.", "error");
            return;
        }
        console.log("Sending to:", recipients);
        const formData = new FormData();
        formData.append("recipients", JSON.stringify(recipients));
        formData.append("template_id", "1");
        formData.append("scheduleTime", "now");
        formData.append("file", "");
        formData.append("testEmail", "True");
        formData.append("subject", subject);
        console.log(content)
        formData.append("content", content);
        try {
            const res = await dispatch(postFormData({ apiUrl, formData })).unwrap();

            if (res && res.success === true) {
                swal("Success!", "Test email sent successfully!", "success").then(() => {
                    setOpenTestEmailPopup(false);
                    setSubject("");
                    setEmailSections([]);
                    setEmailAddresses("")
                    setEditorData("");
                });
            } else {
                alert("Something went wrong!");
            }
        } catch (error) {
            console.log("Error sending test email:", error);
            swal("Error!", "Failed to send test email", "error");
        }
    };

    const pstDate = moment().tz('America/Los_Angeles'); // current PST time
    const [selectedDate, setSelectedDate] = useState(dayjs(pstDate.format('YYYY-MM-DD')));
    const [selectedTime, setSelectedTime] = useState(dayjs(pstDate.format('YYYY-MM-DD HH:mm:ss')));
    const handleSendEmail = async (scheduleLater = false) => {
        const apiUrl = "/sentEmails/send";
        const token = localStorage.getItem("token");
        console.log("token", token);
        if (!token) {
            console.log("No token found");
            swal("Authentication Error", "No token found! Please log in again.", "error");
            return;
        }
        const defaultText = "Thank you for your time!";
        if (!emailSections || emailSections.length === 0 || emailSections.some(row =>
            row.children?.some(column =>
                column.content?.every(section => section.type === "text" && section.content.trim() === defaultText)))) {
            swal("Missing Content", "Email content is empty.", "warning");
            return;
        }
        const { subject, content, subjectPlaceholders, contentPlaceholders } = generateEmailTemplate();
        const formData = new FormData();
        formData.append("subjectPlaceholders", JSON.stringify(subjectPlaceholders));
        formData.append("contentPlaceholders", JSON.stringify(contentPlaceholders));
        let csvFile = uploadedFile;  // Use uploaded file
        console.log("chosenReport", chosenReport);  // If no file was uploaded, fetch the selected report file
        const reportToUse = selectedReport || chosenReport;
        if (!csvFile && reportToUse?.file) {
            try {
                const decodedCSV = atob(reportToUse.file);
                const csvBlob = new Blob([decodedCSV], { type: "text/csv" });
                csvFile = new File([csvBlob], "report.csv", { type: "text/csv" });
            } catch (error) {
                console.log("Error decoding base64 file:", error);
                swal("Error!", "Failed to decode report file.", "error");
                return;
            }
        }
        if (!csvFile && selectedRows && selectedRows.length > 0) {
            try {
                csvFile = generateCSVFile(selectedRows);  // Generate CSV file from selected rows
            } catch (error) {
                console.log("Error generating CSV file:", error);
                swal("Error!", "Failed to generate CSV file.", "error");
                return;
            }
        }
        if (!csvFile) {
            console.log("No CSV file to upload.");
            swal("Error!", "No CSV file selected or generated.", "error");
            return;
        }
        const mergedRecipients = [           // Merge manually added recipients 
            ...(csvFile ? csvFile.recipients || [] : []),  // Use recipients from csvFile 
            ...csvRows  // Manually added recipients
        ];
        const generateFinalCSV = (recipients) => {            // Generate the final CSV with merged recipients
            const headers = [
                "Company Name", "First Name", "Last Name", "Email", 'communication_email', 
                "Phone no.", "address", "city", "state_code", "zip_code", 
                "total_enrollements", "active_enrollements", "totalApprovedCommission", "paidAmount"
            ];
            const rows = recipients.map(r => [              // Map data headers
                r.company_name || "",
                r.first_name || "",
                r.last_name || "",
                r.email || "",
                r.communication_email || "",
                r.phone_no || "",
                r.address || "",
                r.city || "",
                r.state_code || "",
                r.zip_code || "",
                r.total_enrollements || "",
                r.active_enrollements || "",
                r.totalApprovedCommission || "",
                r.paidAmount || ""
            ]);
            const csvContent = [headers, ...rows].map(row => row.join(",")).join("\n");             // Generate the CSV combining headers with data rows
            return csvContent;
        };
        const finalCSV = generateFinalCSV(mergedRecipients);
        const finalCSVBlob = new Blob([finalCSV], { type: "text/csv" });
        const finalCSVFile = new File([finalCSVBlob], "merged_recipients.csv", { type: "text/csv" });
        const generateUniqueFileName = (originalName) => {               // Rename and append the merged file to form data
            const fileExtension = originalName.split('.').pop();  // Get file extension
            return `${Date.now()}_${Math.random().toString(36).substring(7)}.${fileExtension}`;
        };
        const uniqueFileName = generateUniqueFileName(finalCSVFile.name);
        const renamedFile = new File([finalCSVFile], uniqueFileName, { type: finalCSVFile.type });
        formData.append("file", renamedFile);
        formData.append("subject", subject);
        formData.append("content", content);
        if (reportToUse?.id) {
            formData.append("reportId", reportToUse.id);
        }
        let scheduleTime = "now";  // Default
        if (scheduleLater) {
            if (!selectedDate || !selectedTime) {
                swal("Error!", "Please select a date and time to schedule the email.", "error");
                return;
            }
            const combinedDateTime = `${selectedDate.format("YYYY-MM-DD")} ${selectedTime.format("HH:mm:ss")}`;
            const scheduledPST = moment.tz(combinedDateTime, "America/Los_Angeles");
            console.log("Scheduled PST DateTime:", scheduledPST.format());
            scheduleTime = scheduledPST.format("YYYY-MM-DDTHH:mm:ss");
        }
        formData.append("scheduleTime", scheduleTime);
        console.log("CSV File Name:", renamedFile.name);
        console.log("CSV File Type:", renamedFile.type)
        try {
            const res = await dispatch(postFormData({ apiUrl, formData })).unwrap();
            if (res && res.success === true) {
                const successMessage = scheduleLater
                    ? "Email scheduled successfully!"
                    : "Email sent successfully!";
                swal("Success!", successMessage, "success").then(() => {
                    setOpenEmailPopup(false);
                    setEmailSections([]);
                    setSubject("");
                    setChosenReport(null);
                    setEditorData("");
                    navigate(location.pathname, { replace: true, state: {} });
                });
            } else {
                console.log("Error response:", res);
                swal("Error!", res?.message || "Failed to send email", "error");
            }
        } catch (error) {
            swal("Error!", "Failed to send email", "error");
        }
    };
    const handlePreview = () => {
        generateEmailTemplate();
        setOpenPreview(true);
    };
    // IMAGE STYLING
    const handleWidthChange = (event, newValue) => {
        setEmailSections((prev) =>
            prev.map((row) => ({
                ...row,
                children: row.children.map((column) => ({
                    ...column,
                    content: column.content.map((section) =>
                        section.key === selectedSectionKey
                            ? { ...section, imageWidth: newValue } // Store width of image section
                            : section
                    )
                }))
            }))
        );
    };
    const handleAlignmentChange = (align, sectionKey) => {
        setEmailSections((prev) =>
            prev.map((row) => ({
                ...row,
                children: row.children.map((column) => ({
                    ...column,
                    content: column.content.map((section) => {
                        if (section.key !== sectionKey) return section;
                        if (section.type === "button") {                // Check if it's a button section
                            return {
                                ...section,
                                styles: {
                                    ...section.styles,
                                    alignment: align, //
                                },
                            };
                        }
                        return {                 // For image or other types, set it directly
                            ...section,
                            alignment: align,
                        };
                    }),
                })),
            }))
        );
    };
    // TO REPLACE IMAGE 
    const handleReplaceImage = async (event) => {
        const file = event.target.files[0];
        if (!file || !file.type.startsWith("image/")) return;
        const formData = new FormData();
        formData.append("file", file)
        try {
            const res = await dispatch(postFormData({ apiUrl: "/template/saveImage", formData })).unwrap();
            if (res?.success && res?.file) {
                const imageUrl = res.file; //backend URL
                console.log("Uploaded Image URL:", imageUrl);
                setEmailSections((prev) =>
                    prev.map((row) => ({
                        ...row,
                        children: row.children.map((column) => ({
                            ...column,
                            content: column.content.map((section) =>
                                section.key === selectedSectionKey
                                    ? { ...section, imageSrc: imageUrl }
                                    : section
                            ),
                        })),
                    }))
                );
            } else {
                console.error("Upload failed:", res);
            }
        } catch (err) {
            console.error("Image upload error:", err);
        }
    };
    // TO REMOVE IMAGE
    const handleRemoveImage = () => {
        setEmailSections((prev) =>
            prev.map((row) => ({
                ...row,
                children: row.children.map((column) => ({
                    ...column,
                    content: column.content.map((section) =>
                        section.key === selectedSectionKey
                            ? { ...section, imageSrc: "" } //
                            : section
                    ),
                })),
            }))
        );
    };
    //BUTTON STYLES
    const handleStyleChange = (property, value) => {
        setEmailSections((prevSections) =>
            prevSections.map((row) => ({
                ...row,
                children: row.children.map((col) => ({
                    ...col,
                    content: col.content.map((section) =>
                        section.key === selectedSectionKey
                            ? {
                                ...section,
                                styles: {
                                    ...section.styles,
                                    [property]: value,
                                },
                            }
                            : section
                    ),
                })),
            }))
        );
    };
    const handleButtonTextChange = (key, value) => {
        setEmailSections((prevSections) =>
            prevSections.map((row) => ({
                ...row,
                children: row.children.map((col) => ({
                    ...col,
                    content: col.content.map((section) =>
                        section.key === key
                            ? { ...section, content: value }
                            : section
                    ),
                })),
            }))
        );
    };
    // TO DELETE THE ROW
    const handleDeleteRow = (rowKey) => {
        swal({
            title: "Are you sure?",
            text: "Do you really want to delete this row?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((confirm) => {
            if (confirm) {
                setEmailSections((prevSections) => {
                    // TO Check selected section is inside the deleted row
                    const isDeletedSectionSelected = prevSections.some((row) =>
                        row.key === rowKey &&
                        row.children.some((column) =>
                            column.content.some((section) => section.key === selectedSectionKey)
                        )
                    );
                    const newSections = prevSections.filter((row) => row.key !== rowKey); // Filter out the deleted row
                    if (isDeletedSectionSelected) {
                        setSelectedSectionKey(null);
                        setSelectedSection(null);
                        setActiveTab("section");
                    }
                    if (newSections.length === 0) {                 //  Clear location.state if no sections remain
                        navigate(".", { replace: true, state: {} });
                    }
                    return newSections;
                });
            }
        });
    };
    const generateCSVFile = () => {
        if (uploadedFile) {
            console.log("Using uploaded CSV file.");
            return uploadedFile;  // Use the uploaded file directly
        }
        if (!selectedRows || selectedRows.length === 0) {
            console.log("No data available to generate CSV.");
            return null;
        }
        // Define CSV headers
        const headers = ["Company Name", "First Name", "Last Name", "Email", 'communication_email', "Phone no.", "address", "city", "state_code", "zip_code", "total_enrollements", "active_enrollements", "totalApprovedCommission", "paidAmount"];
        const csvRows = selectedRows.map(row => [
            row.company_name || "",
            row.first_name || "",
            row.last_name || "",
            row.email || "",
            row.communication_email || "",
            row.phone_no || "",
            row.address || "",
            row.city || "",
            row.state_code || "",
            row.zip_code || "",
            row.total_enrollements || "",
            row.active_enrollements || "",
            row.totalApprovedCommission || "",
            row.paidAmount || ""
        ]);
        const csvContent = [headers, ...csvRows].map(row => row.join(",")).join("\n");
        const csvBlob = new Blob([csvContent], { type: "text/csv" });        // Convert CSV 
        const uniqueFileName = `contacts_${Date.now()}.csv`;         // Generate a UNIQUE filename 
        return new File([csvBlob], uniqueFileName, { type: "text/csv" });        //  new File object 
    };
    const [csvRows, setCsvRows] = useState([]);
    const [csvColumns, setCsvColumns] = useState([]);
    useEffect(() => {
        const processCSV = (csvText) => {
            if (typeof csvText !== "string") {
                console.log("CSV data is not a string:", csvText);
                return;
            }
            const [headerLine, ...lines] = csvText.trim().split("\n");
            if (!headerLine) return;
            const headers = headerLine.split(",").map(h => {
                const sanitizedField = h.trim().replace(/\W+/g, "_").toLowerCase();
                return {
                    field: sanitizedField,
                    headerName: h.trim(),
                    flex: 1,
                    minWidth: 150,
                };
            });
            const rows = lines.map((line, index) => ({
                id: index + 1,
                ...Object.fromEntries(headers.map((h, i) => [h.field, line.split(",")[i] || ""]))
            }));

            setCsvColumns(headers);
            setCsvRows(rows);
        };
        if (uploadedFile) {
            const reader = new FileReader();
            reader.onload = (e) => processCSV(e.target.result);
            reader.readAsText(uploadedFile);
        } else if (chosenReport?.file) {
            try {
                const decoded = atob(chosenReport.file);
                processCSV(decoded);
            } catch (err) {
                console.log("Error decoding chosenReport:", err);
            }
        } else if (selectedReport?.file) {
            try {
                const decoded = atob(selectedReport.file);
                processCSV(decoded);
            } catch (err) {
                console.log("Error decoding selectedReport:", err);
            }
        } else if (selectedRows.length > 0) {
            const csvFile = generateCSVFile();
            if (csvFile) {
                const reader = new FileReader();
                reader.onload = (e) => processCSV(e.target.result);
                reader.readAsText(csvFile);
            }
        } else {
            setCsvRows([]);
            setCsvColumns([]);
        }
    }, [uploadedFile, chosenReport, selectedReport]);
    const handleViewCSV = () => {
        setOpenCSVPopup(true);
    };
    const [openForm, setOpenForm] = useState(false); // Recipient popup
    const [selectedTableRows, setSelectedTableRows] = useState([]);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("");
    const [confirmAction, setConfirmAction] = useState(() => () => { });
    useEffect(() => {          // to show the checkbox selected for the table by default
        if (csvRows.length) {
            setSelectedTableRows(csvRows.map((row) => row.id));
        }
    }, [csvRows]);
    const openConfirmation = (message, action) => {      //  open the confirmation dialog
        setConfirmMessage(message);
        setConfirmAction(() => action); // Store  function to SHOW on confirm
        setOpenConfirm(true);
    };
    const handleSelectionChange = (selection) => {     // TO SELECT THE ROW OF THE TABLE TO DELETE
        setSelectedTableRows(selection);
    };
    const handleDeleteSelected = () => {        //to delete selected csv rows
        setCsvRows(csvRows.filter((row) => !selectedTableRows.includes(row.id)));
        setSelectedTableRows([]); // Clear selection after delete
    };
    // to add new Recipient
    const requiredFields = ["company_name", "first_name", "last_name", "email"];
    const filteredColumns = csvColumns.filter(col =>         // Filter  required fields
        requiredFields.includes(col.field.trim().toLowerCase())
    );
    // Initialize values only for required fields
    const initialValues = Object.fromEntries(filteredColumns.map(col => [col.field, ""]));
    const validationSchema = Yup.object().shape(
        Object.fromEntries(filteredColumns.map(col => {
            if (col.field.toLowerCase() === "email") {
                return [col.field, Yup.string()
                    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email format")
                    .email("Invalid email format")
                    .required("Email is required")
                ];
            }
            if (col.field.toLowerCase() === "company_name") {
                return [col.field, Yup.string().required("Company name is required")];
            }
            return [col.field, Yup.string()];
        }))
    );

    const ContentLayout =
        <>
            <DndProvider backend={HTML5Backend} >
                <Grid container lg={12} md={12} xs={12} sm={12} >
                    <Box container lg={12} md={12} xs={12} sm={12} sx={{
                        display: "contents", justifyContent: "space-between", alignItems: "center",
                    }}>
                        <Box item flexGrow={1}>
                            <Typography variant="h6" className="emailTitle">
                                Create Email
                            </Typography>
                        </Box>
                        <Box item className="buttonContainer" sx={{ display: "flex", gap: 1, marginRight: '12px' }}>
                            <Button className="saveDraft" variant="contained" onClick={handleSaveDraftClick}>Save Draft</Button>
                            <Button className="sendEmail" variant="contained" onClick={handleSendEmailClick}>Send Email</Button>
                            <Button className="testEmail" variant="outlined" onClick={handleSendTestEmailClick}>Send Test Email</Button>
                            <Button className="preview" variant="outlined" onClick={handlePreview}>PREVIEW</Button>
                            <Button className="cancel" variant="outlined" onClick={handleReset}>Reset</Button>
                        </Box>
                    </Box>
                    <Grid container item lg={12} md={12} xs={12} sm={12} sx={{ marginTop: "30px", position: "relative", zIndex: 1 }}>
                        <Grid item lg={7} md={6} sm={12} xs={12}>
                            <Box className="emailBox" sx={{ padding: '20px', maxHeight: '70vh', overflowY: 'auto' }}>
                                {emailSections.length > 0 ? (
                                    emailSections.map((section, index) => (
                                        <React.Fragment key={section.key}>
                                            {/* Render Sections */}
                                            {section.type === "row" ? (
                                                <Box
                                                    className={`emailRow ${section.className}`}
                                                    sx={{ display: "flex", gap: "10px", marginBottom: "10px", border: "1px solid #ccc", padding: "10px", position: "relative" }}>
                                                    <IconButton className="deleteIconROW"
                                                        onClick={() => handleDeleteRow(section.key)}                                                   >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                    {section.children.map((column) => (
                                                        <Box
                                                            key={column.key}
                                                            className={column.className}
                                                            sx={{
                                                                width: section.isSavedTemplate && column.width
                                                                    ? `${column.width}`  // Apply extracted width
                                                                    : "auto", // Default for normal sections                                                 
                                                                flex: !section.isSavedTemplate
                                                                    ? (column.className.includes("large-10") ? 10
                                                                        : column.className.includes("small-2") ? 2
                                                                            : 1) //   flex logic for normal sections
                                                                    : "unset",  //  Avoid for extracted templates,
                                                                border: "1px solid gray",
                                                                padding: "10px",
                                                                minHeight: "60px",
                                                                flexDirection: "column",
                                                                alignItems: "stretch",
                                                                height: "auto",
                                                            }}
                                                        >{/* to Render dropped SECTIONS inside the column */}
                                                            {column.content && column.content.length > 0 &&
                                                                column.content.map((item) => (
                                                                    <React.Fragment key={item.key}>
                                                                        <DropZone targetKey={column.key} insertBeforeKey={item.key} onDrop={handleDrop} />
                                                                        <EmailSection
                                                                            section={item}
                                                                            className={`emailSection ${item.className || ""}`}
                                                                            onDrop={handleDrop}
                                                                            onClick={() => handleSectionClick(item.key)}
                                                                            onEdit={(newContent) => handleEdit(item.key, newContent)}
                                                                            onDelete={() => handleDelete(item.key)}
                                                                            selectedSectionKey={selectedSectionKey}
                                                                            handleReplaceImage={handleReplaceImage}
                                                                            handleRemoveImage={handleRemoveImage}
                                                                            editorData={editorData}
                                                                            setEditorData={setEditorData}
                                                                            updateSectionContent={updateSectionContent}
                                                                        />
                                                                    </React.Fragment>
                                                                ))
                                                            }
                                                            <DropZone targetKey={column.key} onDrop={handleDrop} isEmpty={!column.content || column.content.length === 0} />
                                                        </Box>
                                                    ))}
                                                </Box>
                                            ) : (
                                                //  Normal Sections
                                                <EmailSection
                                                    key={section.key}
                                                    section={section}
                                                    className={`emailSection ${section.className}`}
                                                    onDrop={handleDrop}
                                                    onEdit={handleEdit}
                                                    onDelete={handleDelete}
                                                    onClick={() => handleSectionClick(section.key)}
                                                    selectedSectionKey={selectedSectionKey}
                                                    handleReplaceImage={handleReplaceImage}
                                                    handleRemoveImage={handleRemoveImage}
                                                    editorData={editorData}
                                                    setEditorData={setEditorData}
                                                    updateSectionContent={updateSectionContent}
                                                />
                                            )}
                                            <DropZone targetKey={section.key} onDrop={handleDrop} isRowDropZone={true} isLastRow={index === emailSections.length - 1} />
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <EmptyDropZone onDrop={handleDrop} />
                                )}
                            </Box>
                        </Grid>
                        <Grid item lg={5} md={6} sm={12} xs={12} sx={{ borderRadius: 1, borderWidth: 1, borderColor: '#CDCCCC', borderStyle: 'solid', padding: 2 }}>
                            <Grid item sx={{ display: 'flex', flexDirection: 'column', }}>
                                <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                    <Button variant="outlined" className="commonOutlinedBtn" onClick={() => navigate("/saved-templates")}>
                                        Saved Template
                                    </Button>
                                    <Button variant="outlined" className="commonOutlinedBtn" onClick={() => navigate("/default-templates")}>
                                        Use Default Template
                                    </Button>
                                </Box>
                                <hr style={{ border: '1px solid #9F9696', width: '100%', margin: 0 }} />
                                <Box className="section-box" sx={{ mt: 1, mb: 1 }}>
                                    <Typography variant="body1" className="rubik-text">
                                        Drag & drop Section Layout
                                    </Typography> {/* Grid Layout  */}
                                    <Box className="layout-container">
                                        <DraggableRow type="full-width" rowKey="row-1">
                                            <Card sx={{ boxShadow: 2, borderRadius: '8px', width: '100%' }}>
                                                <CardContent sx={{ padding: '8px' }}>
                                                    <Box className="grid-box full-width">12</Box>
                                                </CardContent>
                                            </Card>
                                        </DraggableRow>
                                        <DraggableRow type="half-width" rowKey="row-2">
                                            <Card sx={{ boxShadow: 2, borderRadius: '8px', width: '100%' }}>
                                                <CardContent sx={{ padding: '8px', display: 'flex', gap: '10px' }}>
                                                    <Box className="grid-box half-width">6</Box>
                                                    <Box className="grid-box half-width">6</Box>
                                                </CardContent>
                                            </Card>
                                        </DraggableRow>
                                        <DraggableRow type="large-small" rowKey="row-3">
                                            <Card sx={{ boxShadow: 2, borderRadius: '8px', width: '100%' }}>
                                                <CardContent sx={{ padding: '8px', display: 'flex', gap: '10px' }}>
                                                    <Box className="grid-box large-10">10</Box>
                                                    <Box className="grid-box small-2">2</Box>
                                                </CardContent>
                                            </Card>
                                        </DraggableRow>
                                        <DraggableRow type="small-large" rowKey="row-4">
                                            <Card sx={{ boxShadow: 2, borderRadius: '8px', width: '100%' }}>
                                                <CardContent sx={{ padding: '8px', display: 'flex', gap: '10px' }}>
                                                    <Box className="grid-box small-2">2</Box>
                                                    <Box className="grid-box large-10">10</Box>
                                                </CardContent>
                                            </Card>
                                        </DraggableRow>
                                    </Box>
                                </Box>
                                <Box className="Edit-sectionTabs">
                                    <Typography variant="body1" className="rubik-text" sx={{ mt: 1, mb: 1 }}>
                                        Edit Your Preheader Section
                                    </Typography>
                                    <Box className="tab-container">
                                        <Box
                                            className={`tab ${activeTab === "section" ? "active" : ""}`}
                                            onClick={() => setActiveTab("section")}
                                            style={{ cursor: "pointer", padding: "10px" }}
                                        >
                                            Section
                                        </Box>
                                        <Box
                                            className={`tab ${activeTab === "style" ? "active" : ""}`}
                                            onClick={() => setActiveTab("style")}
                                            style={{ cursor: "pointer", padding: "10px" }}
                                        >
                                            Section Styling
                                        </Box>
                                    </Box>
                                </Box>
                                {activeTab === "style" ? (
                                    <>
                                        {/* IMAGE STYLING */}
                                        {emailSections
                                            .flatMap(row => row.children)
                                            .flatMap(column => column.content)
                                            .find(section => section.key === selectedSectionKey)?.type === "image" && (
                                                <Box sx={{ mt: 1, fontWeight: "bold", textAlign: "left", color: "#000000", fontSize: "14px" }}>
                                                    <Box>
                                                        <Box className="scale-image-container">
                                                            <Typography variant="body2" gutterBottom sx={{ flexShrink: 0, marginRight: '8px' }}>
                                                                Scale Image
                                                            </Typography>
                                                            <Slider
                                                                value={
                                                                    emailSections
                                                                        .flatMap(row => row.children)
                                                                        .flatMap(column => column.content)
                                                                        .find(section => section.key === selectedSectionKey)?.imageWidth || 50
                                                                }
                                                                min={10} max={100} step={5}
                                                                onChange={handleWidthChange}
                                                                valueLabelDisplay="auto"
                                                                valueLabelFormat={(value) => `${value}%`}
                                                                sx={{ width: '100%' }}
                                                            />
                                                        </Box>
                                                        <Box className="actions-container">
                                                            <Box className="align-buttons">
                                                                <Typography variant="body2">Align Image</Typography>
                                                                {["left", "center", "right"].map((align) => (
                                                                    <IconButton
                                                                        key={align}
                                                                        onClick={() => handleAlignmentChange(align, selectedSectionKey)}
                                                                        color={
                                                                            emailSections
                                                                                .flatMap(row => row.children)
                                                                                .flatMap(column => column.content)
                                                                                .find(section => section.key === selectedSectionKey)?.alignment === align
                                                                                ? "primary"
                                                                                : "default"
                                                                        }
                                                                    >
                                                                        {align === "left" && <FormatAlignLeft sx={{ fontSize: "15px" }} />}
                                                                        {align === "center" && <FormatAlignCenter sx={{ fontSize: "15px" }} />}
                                                                        {align === "right" && <FormatAlignRight sx={{ fontSize: "15px" }} />}
                                                                    </IconButton>
                                                                ))}
                                                            </Box>
                                                            <Box className="button-group">
                                                                <Box variant="contained" component="label" className="ReplaceButton">
                                                                    <ImageIcon sx={{ fontSize: "15px" }} />
                                                                    <Typography variant="body2">Replace Image</Typography>
                                                                    <input type="file" accept="image/*" hidden onChange={handleReplaceImage} />
                                                                </Box>
                                                                <Box variant="outlined" className="RemoveButton" onClick={handleRemoveImage}>
                                                                    <ImageIcon sx={{ fontSize: "15px" }} />
                                                                    <Typography variant="body2">Remove Image</Typography>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            )}
                                        {/* BUTTON STYLING */}
                                        {emailSections
                                            .flatMap(row => row.children)
                                            .flatMap(column => column.content)
                                            .find(section => section.key === selectedSectionKey)?.type === "button" && (
                                                <Grid container spacing={1} sx={{ mt: 2 }}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="body2">Button Text</Typography>
                                                        <input
                                                            type="text"
                                                            value={emailSections
                                                                .flatMap(row => row.children)
                                                                .flatMap(column => column.content)
                                                                .find(section => section.key === selectedSectionKey)?.content || ""}
                                                            onChange={(e) => handleButtonTextChange(selectedSectionKey, e.target.value)}
                                                            style={{ width: "100%", padding: "6px", fontSize: "14px" }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography variant="body2">Font Size</Typography>
                                                        <Slider min={10} max={30} step={1}
                                                            value={parseInt(
                                                                emailSections
                                                                    .flatMap(row => row.children)
                                                                    .flatMap(column => column.content)
                                                                    .find(section => section.key === selectedSectionKey)?.styles?.fontSize || "16"
                                                            )}
                                                            onChange={(e, value) => handleStyleChange("fontSize", `${value}px`)}
                                                            valueLabelDisplay="auto"
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography variant="body2">Border Radius</Typography>
                                                        <Slider min={0} max={30} step={1}
                                                            value={parseInt(
                                                                emailSections
                                                                    .flatMap(row => row.children)
                                                                    .flatMap(column => column.content)
                                                                    .find(section => section.key === selectedSectionKey)?.styles?.borderRadius || "4"
                                                            )}
                                                            onChange={(e, value) => handleStyleChange("borderRadius", `${value}px`)}
                                                            valueLabelDisplay="auto"
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>   {/* Align Button */}
                                                        <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ gap: 2 }}>
                                                            <Box display="flex" alignItems="center">
                                                                <Typography variant="body2" sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                                                                    Align Button
                                                                </Typography>
                                                                {["left", "center", "right"].map((align) => (
                                                                    <IconButton
                                                                        key={align}
                                                                        onClick={() => handleAlignmentChange(align, selectedSectionKey)}
                                                                        color={
                                                                            emailSections
                                                                                .flatMap(row => row.children)
                                                                                .flatMap(column => column.content)
                                                                                .find(section => section.key === selectedSectionKey)?.styles?.alignment === align ? "primary" : "default"
                                                                        }
                                                                        size="small"
                                                                    >
                                                                        {align === "left" && <FormatAlignLeft sx={{ fontSize: "18px" }} />}
                                                                        {align === "center" && <FormatAlignCenter sx={{ fontSize: "18px" }} />}
                                                                        {align === "right" && <FormatAlignRight sx={{ fontSize: "18px" }} />}
                                                                    </IconButton>
                                                                ))}
                                                            </Box>
                                                            {/* Text Spacing */}
                                                            <Box display="flex" alignItems="center">
                                                                <Typography variant="body2" sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                                                                    Text Spacing
                                                                </Typography>
                                                                <input
                                                                    type="text"
                                                                    value={
                                                                        emailSections
                                                                            .flatMap(row => row.children)
                                                                            .flatMap(column => column.content)
                                                                            .find(section => section.key === selectedSectionKey)?.styles?.padding || "12px 24px"
                                                                    }
                                                                    onChange={(e) => handleStyleChange("padding", e.target.value)}
                                                                    placeholder="12px 24px"
                                                                    style={{ padding: "6px", fontSize: "14px", width: "120px", border: "1px solid #ccc", borderRadius: "4px", }}
                                                                />
                                                            </Box>
                                                        </Box>
                                                    </Grid>

                                                </Grid>
                                            )}
                                        {/* COLOR PICKERS */}
                                        <Grid container spacing={1} className="color-picker-grid">
                                            <Grid item xs={12} sx={{ borderBottom: "1px solid #CDCCCC", pb: 1 }}>
                                                <Box sx={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                                        <Typography>Background color</Typography>
                                                        <Box
                                                            onClick={() => togglePicker("bg")}
                                                            sx={{ width: "1.5rem", height: "1.5rem", border: "1px solid #aaa", cursor: "pointer", backgroundColor: bgColor, }}
                                                        />
                                                        <Typography sx={{ cursor: "pointer" }} onClick={() => handleColorChange("bgColor", "transparent")}>
                                                            Remove background color
                                                        </Typography>
                                                    </Box>
                                                    {openPicker === "bg" && (
                                                        <ChromePicker color={bgColor} onChange={(color) => handleColorChange("bgColor", color.hex)} />
                                                    )}
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sx={{ borderBottom: "1px solid #CDCCCC", pb: 1 }}>
                                                <Box sx={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                                        <Typography>Border</Typography>
                                                        <Box
                                                            onClick={() => togglePicker("border")}
                                                            sx={{ width: "1.5rem", height: "1.5rem", border: "1px solid #aaa", cursor: "pointer", backgroundColor: borderColor, }}
                                                        />
                                                    </Box>
                                                    {openPicker === "border" && (
                                                        <ChromePicker color={borderColor} onChange={(color) => handleColorChange("borderColor", color.hex)} />
                                                    )}
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sx={{ borderBottom: "1px solid #CDCCCC", pb: 1 }}>
                                                <Box sx={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                                        <Typography>Text</Typography>
                                                        <Box
                                                            onClick={() => togglePicker("text")}
                                                            sx={{ width: "1.5rem", height: "1.5rem", border: "1px solid #aaa", cursor: "pointer", backgroundColor: textColor, }}
                                                        />
                                                    </Box>
                                                    {openPicker === "text" && (
                                                        <ChromePicker color={textColor} onChange={(color) => handleColorChange("textColor", color.hex)} />
                                                    )}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </>
                                ) : (
                                    // Default section rendering
                                    <Grid container spacing={1} sx={{ mt: 1, mb: 1, ml: 2 }}>
                                        <Typography className="rubik-text">Drag and drop to add section to compose mail</Typography>
                                        <Grid container spacing={1} sx={{ mt: 1, mb: 1 }}>
                                            {["Preheader", "Header", "Paragraph", "Button", "Image", "Footer"].map((item) => (
                                                <Grid item xs={4} key={item}>
                                                    <DraggableItem type={item} />
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DndProvider>
            <Dialog open={openPreview} onClose={() => setOpenPreview(false)} maxWidth="md" fullWidth>
                <DialogTitle>
                    Email Preview
                    <IconButton edge="end" color="inherit" onClick={() => setOpenPreview(false)} aria-label="close"
                        sx={{ position: 'absolute', right: 8, top: 8, }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {htmlContent ? (
                        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
                    ) : (
                        <div dangerouslySetInnerHTML={{ __html: emailContent || htmlContent }} />
                    )}
                </DialogContent>
            </Dialog>
            <Dialog open={openEmailPopup} onClose={() => setOpenEmailPopup(false)} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Send Email
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={() => setOpenEmailPopup(false)}
                        aria-label="close"
                        sx={{ position: 'absolute', right: 8, top: 8, }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        {!isUsingFetchedRecipients && (<Select
                            fullWidth
                            displayEmpty
                            size="small"
                            value={chosenReport?.id || ""}
                            onChange={(e) => {
                                const selectedId = parseInt(e.target.value);
                                const selectedReportOBJ = availableReports.find(r => r.id === selectedId);
                                setChosenReport(selectedReportOBJ);
                            }}
                            renderValue={() =>
                                chosenReport?.name || "Select a Report"
                            }
                        >
                            <MenuItem value="" disabled>
                                Select a Report
                            </MenuItem>
                            {loadingReports ? (
                                <MenuItem disabled>
                                    <CircularProgress size={20} sx={{ mr: 1 }} /> Loading Reports...
                                </MenuItem>
                            ) : (
                                availableReports
                                    .filter(report => report?.id && report?.name?.trim())
                                    .map((report) => (
                                        <MenuItem key={report.id} value={report.id}>
                                            {report.name}
                                        </MenuItem>
                                    ))
                            )}
                        </Select>)}
                        <TextField
                            label="To"
                            size="small"
                            variant="outlined"
                            placeholder="Recipient email id"
                            value={csvRows.length > 0 ? `${csvRows.length} Recipient${csvRows.length > 1 ? "s" : ""} Selected` : ""}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleViewCSV}>
                                            <Visibility />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            label="From"
                            size="small"
                            variant="outlined"
                            value="bruce.cornelious@myfreescorenow.com"
                        />
                        <TextField
                            label="Subject"
                            size="small"
                            variant="outlined"
                            placeholder="<First Name>"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                        />
                        <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                            <Button variant="contained" className="send-button" onClick={() => {
                                if (!subject) {
                                    swal("Please enter a subject before sending the email.");
                                    return;
                                }
                                openConfirmation("Do you want to send the email now?", () => handleSendEmail(false));
                            }}>
                                Send Now
                            </Button>
                            <Button variant="outlined" className="commonOutlinedBtn" onClick={handleScheduleLaterClick} >Schedule for Later</Button>
                        </Box>
                        {openScheduleSection && <Box sx={{ mt: 1 }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Select Date"
                                    value={selectedDate}
                                    disablePast
                                    onChange={(newDate) => setSelectedDate(newDate)}
                                    sx={{ width: "100%", mb: 2 }}
                                />
                                <TimePicker
                                    label="Select Time"
                                    value={selectedTime}
                                    onChange={(newTime) => setSelectedTime(newTime)}
                                    sx={{ width: "100%" }}
                                />
                            </LocalizationProvider>
                            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                <Button variant="contained" className="schedule-button" onClick={() => {
                                    if (!subject) {
                                        swal("Please enter a subject before scheduling the email.");
                                        return;
                                    }
                                    openConfirmation("Do you want to schedule the email?", () => handleSendEmail(true));
                                }}>Schedule</Button>
                                <Button variant="outlined" className="commonOutlinedBtn" onClick={handleCancelClick}>Cancel</Button>
                            </Box>
                        </Box>}
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog open={openCSVPopup} onClose={() => setOpenCSVPopup(false)} maxWidth="md" fullWidth>
                <DialogTitle>
                    CSV Data
                    <IconButton
                        edge="end" handleViewCSV
                        color="inherit"
                        onClick={() => setOpenCSVPopup(false)}
                        aria-label="close"
                        sx={{ position: 'absolute', right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {csvRows.length ? (
                        <Box sx={{ width: "100%", overflowX: "auto", height: 400 }}>
                            <DataGrid
                                rows={csvRows}
                                columns={csvColumns.map((col) => ({
                                    ...col,
                                    editable: ["First Name", "Last Name", "Email", "Phone no."].includes(col.headerName), // EDIT ONLY Column header names
                                }))}
                                pageSizeOptions={[10, 20, 50]}
                                pagination
                                checkboxSelection
                                rowSelectionModel={selectedTableRows}  // TO show checkbox selected by default
                                onRowSelectionModelChange={handleSelectionChange}
                                autoHeight
                                processRowUpdate={(updatedRow, oldRow) => {
                                    // Update state after editing a row
                                    setCsvRows((prevRows) =>
                                        prevRows.map((row) => (row.id === updatedRow.id ? updatedRow : row))
                                    );
                                    return updatedRow;
                                }}
                                onProcessRowUpdateError={(error) => {
                                    console.log("Error updating row:", error);
                                }}
                                slots={{ toolbar: GridToolbar }}
                                slotProps={{
                                    toolbar: { showQuickFilter: true }
                                }}
                                sx={{
                                    "& .MuiDataGrid-columnHeaders": {
                                        backgroundColor: "#2E67BC",
                                        color: "#fff",
                                        fontWeight: "bold"
                                    }
                                }}
                            />
                        </Box>
                    ) : (
                        <Typography>No CSV data available.</Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained" color="error" disabled={selectedTableRows.length === 0} onClick={() => openConfirmation("Are you sure you want to delete the selected recipients?", handleDeleteSelected)}
                        startIcon={<DeleteIcon />}
                    >
                        Delete Selected
                    </Button>
                    <Button variant="contained" className="send-button" onClick={() => setOpenForm(true)} startIcon={<AddIcon />} disabled={!csvRows || csvRows.length === 0}>
                        Add New Recipient
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openTestEmailPopup} onClose={() => setOpenTestEmailPopup(false)} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Send Test Email
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={() => setOpenTestEmailPopup(false)}
                        aria-label="close"
                        sx={{ position: 'absolute', right: 8, top: 8, }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <TextField
                            label="Subject"
                            size="small"
                            variant="outlined"
                            placeholder="Subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                        />
                        <TextField
                            label="Enter email addresses"
                            size="small"
                            value={emailAddresses}
                            onChange={handleEmailChange}
                            fullWidth
                            placeholder="Enter emails separated by commas"
                            sx={{ marginTop: 2 }}
                        />
                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Button variant="contained" className="send-button" onClick={handleSendTestEmail}>Send Test Email</Button>
                            <Button variant="outlined" className="commonOutlinedBtn" onClick={() => setOpenTestEmailPopup(false)}>Cancel</Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog open={openSaveDraftPopup} onClose={() => setOpenSaveDraftPopup(false)} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Save Draft
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={() => setOpenSaveDraftPopup(false)}
                        aria-label="close"
                        sx={{ position: 'absolute', right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <TextField
                            label="Subject"
                            size="small"
                            variant="outlined"
                            placeholder="Enter Subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            fullWidth
                        />
                        <TextField
                            label="Template Name"
                            size="small"
                            variant="outlined"
                            placeholder="Enter Template Name"
                            value={templateName}
                            onChange={(e) => setTemplateName(e.target.value)}
                            fullWidth
                        />
                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Button variant="contained" className="send-button" onClick={handleSaveDraft}>
                                Save
                            </Button>
                            <Button variant="outlined" className="commonOutlinedBtn" onClick={() => setOpenSaveDraftPopup(false)}>
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
            {/* TO ADD NEW RECIPINENT */}
            <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Add New Recipient</DialogTitle>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values, { resetForm }) => {
                        setCsvRows([...csvRows, { id: csvRows.length + 1, ...values }]);
                        setOpenForm(false);
                        resetForm();
                        swal("Success!", "Recipient has been added successfully.", "success");
                    }}
                >
                    {({ values, handleChange, handleBlur, errors, touched }) => (
                        <Form>
                            <Box display="grid" gridTemplateColumns={{ xs: "1fr", sm: "repeat(2, 1fr)" }} gap={2} sx={{ mt: 2, p: 2 }}>
                                {filteredColumns.map((item) => (
                                    <TextField
                                        key={item.field}
                                        name={item.field}
                                        size="small"
                                        label={item.headerName}
                                        value={values[item.field] || ""}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        fullWidth
                                        error={touched[item.field] && Boolean(errors[item.field])}
                                        helperText={touched[item.field] && errors[item.field]}
                                    />
                                ))}
                            </Box>
                            <DialogActions>
                                <Button onClick={() => setOpenForm(false)} variant="outlined" className="commonOutlinedBtn">Cancel</Button>
                                <Button type="submit" variant="contained" className="send-button">Add</Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
            <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>{confirmMessage}</DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirm(false)} color="primary">Cancel</Button>
                    <Button onClick={() => { confirmAction(); setOpenConfirm(false); }} color="error" variant="contained">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    return (
        <>
            <DefaultLayout content={ContentLayout} />
            <div>
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={freez} onClick={handleFreezStop}>
                    <Freez />
                </Backdrop>
            </div></>
    );
}
export default EmailEditor;